import {
  productPageContainer,
  cartPageContainer,
  placeholder,
  addOn,
  styles,
  TOKENS,
  STYLE_TOKENS,
  CssClasses,
  OPTIONS_TOKENS,
  button,
  checkbox,
  qtyBox,
  qtyDropdown,
  variantDropdown
} from './templates';
import getAddOnDetails from './getAddOnDetails';
import errorHandler from './errorHandler';
import { addOnCheckboxActionHandler } from './cartActionHandler';
import { PAGE, BOX_TYPE, LAYOUT_TYPE } from './domain';
import { getPriceDetails } from './utils';
import { variantSelectionHandler } from './variantSelectionHandler';
import createSlider from './slider';
const KNOWN_CONTAINER_ID = 'upsell-container';
export default function(options, addOns, page) {
  const cartForm = getForm(page, options);
  if (!cartForm) {
    removeUpsell();
    return;
  }

  const addToCartButton = getSubmitButton(options, cartForm, page);
  const isAriaDisabled =
    addToCartButton &&
    addToCartButton.getAttribute('aria-disabled') &&
    addToCartButton.getAttribute('aria-disabled') === 'true';
  if (
    addOns.length === 0 ||
    !addToCartButton ||
    ((addToCartButton.disabled || isAriaDisabled) &&
      !options.displayOnDisabledCartButton)
  ) {
    removeUpsell();
  } else {
    if (
      page === PAGE.Product &&
      (options.addOnType === 'checkbox' ||
        options.addOnType === 'dropdown' ||
        options.quantitySelect)
    ) {
      addOnCheckboxActionHandler(cartForm, addToCartButton, options);
    }
    if (options.groupVariants) {
      variantSelectionHandler(options);
    }
    const hasSlider =
      (page === PAGE.Product && options.productLayout === LAYOUT_TYPE.Slider) ||
      (page === PAGE.Cart && options.cartLayout === LAYOUT_TYPE.Slider);
    buildaddOnsHtml(addToCartButton, options, addOns, page, function(
      addOnsHtml
    ) {
      if (!addOnsHtml) {
        removeUpsell();
        return;
      }
      const addOnContainer = document.querySelector(
        `.${CssClasses.addOnContainer}`
      );
      if (addOnContainer) {
        addOnContainer.innerHTML = '';
        if (hasSlider) {
          addOnContainer.className = `${addOnContainer.className} ${CssClasses.invisible}`;
        }
        addOnContainer.insertAdjacentHTML('afterbegin', addOnsHtml);
        if (hasSlider) {
          createSlider(function() {
            new Flickity(addOnContainer, {
              pageDots: false,
              contain: true,
              freeScroll: true,
              cellAlign: 'left'
            });
            addOnContainer.className = addOnContainer.className.replace(
              CssClasses.invisible,
              ''
            );
          });
        }
      }
    });
  }
}
export function renderPlaceholder(options, page) {
  injectStyles(options, page);

  const containerTemplate =
    page === PAGE.Product
      ? productPageContainer(options.productLayout || LAYOUT_TYPE.Default)
      : cartPageContainer(options.cartLayout || LAYOUT_TYPE.Default);
  const containerHtml = buildContainer(containerTemplate, options);
  const loading = containerHtml.replace(TOKENS.addOns, placeholder());

  if (tryRenderInKnownContainer(loading)) return;

  const cartForm = getForm(page, options);

  if (!cartForm) return;

  if (page === PAGE.Product) {
    if (options.position === 'end') {
      cartForm.insertAdjacentHTML('afterend', loading);
    } else if (options.position === 'before') {
      cartForm.insertAdjacentHTML('beforebegin', loading);
    } else {
      const addToCartButton = getSubmitButton(options, cartForm, page);

      if (!addToCartButton) return;

      if (options.position === 'after') {
        addToCartButton.insertAdjacentHTML('afterend', loading);
      } else {
        addToCartButton.insertAdjacentHTML('beforebegin', loading);
      }
    }
  } else {
    if (options.cart === 'bottom') {
      cartForm.insertAdjacentHTML('afterend', loading);
      return;
    }

    let cartElement = cartForm;
    if (options.cart === 'submit') {
      const checkoutButton = getSubmitButton(options, cartForm);
      if (checkoutButton) {
        cartElement = checkoutButton;
      }
    }

    cartElement.insertAdjacentHTML('beforebegin', loading);
  }
}

export function removeUpsell() {
  const container = document.querySelector(`.${CssClasses.container}`);
  if (container) {
    container.remove();
  }
}

function tryRenderInKnownContainer(loading) {
  const knownContainer = document.querySelector(`#${KNOWN_CONTAINER_ID}`);
  if (knownContainer) {
    knownContainer.insertAdjacentHTML('afterbegin', loading);
    return true;
  }
  return false;
}
function buildContainer(containerTemplate, options) {
  return containerTemplate
    .replace(TOKENS.headerText, options.headerText)
    .replace(
      STYLE_TOKENS.header,
      options.showHeaderText && options.headerText ? '' : CssClasses.hidden
    );
}

function buildaddOnsHtml(addToCartButton, options, addOns, page, callback) {
  let callCounts = 0;
  const addonsHtmlOrder = new Array(addOns.length);
  for (let i = 0; i < addOns.length; i++) {
    try {
      const addOnRecord = addOns[i];
      if (addOnRecord.ids && addOnRecord.ids.length > 0) {
        window.upsell = window.upsell || {};
        window.upsell.addons = [];

        getAddOnDetails(addOnRecord.handle, addOnRecord.ids, options, function(
          addOnDetails
        ) {
          callCounts++;
          try {
            if (addOnDetails) {
              const isGroupedVariant =
                addOnDetails.variantOptions &&
                addOnDetails.variantOptions.length > 0;

              const priceDetails = getPrices(options, addOnDetails, 0);
              const addToCartInput =
                getAddToCartInputTemplate(options, page) ||
                getAddOnInput(
                  options,
                  page,
                  addToCartButton,
                  isGroupedVariant,
                  addOnRecord.handle
                );
              const image = getImageUrl(options, addOnDetails, 0);
              const addCartHtml = addToCartInput
                .replace(TOKENS.id, addOnRecord.ids[0])
                .replace(
                  new RegExp(TOKENS.addToCartText, 'g'),
                  options.addToCartText
                    ? decodeURIComponent(options.addToCartText)
                    : 'Add to cart'
                )
                .replace(
                  TOKENS.removeFromCartText,
                  options.removeFromCartText
                    ? decodeURIComponent(options.removeFromCartText)
                    : 'Remove from cart'
                );

              const addOnHtml = (
                getAddOnInputTemplate(options, page) ||
                addOn(
                  page === PAGE.Product
                    ? options.productBoxType || BOX_TYPE.Default
                    : page === PAGE.Cart
                    ? options.cartBoxType
                    : BOX_TYPE.Default
                )
              )
                .replace(TOKENS.addOnProductHandle, addOnRecord.handle)
                .replace(
                  OPTIONS_TOKENS.titleSnippet,
                  options.linkTitle
                    ? `<a href="${getUrl(addOnDetails, 0)}"   ${
                        options.linkInNewPage ? 'target="_blank"' : ''
                      }>${addOnDetails.title}</a>`
                    : addOnDetails.title
                )
                .replace(TOKENS.img, image)
                .replace(
                  OPTIONS_TOKENS.imageClassName,
                  image ? CssClasses.image : CssClasses.hidden
                )
                .replace(
                  OPTIONS_TOKENS.seeDetails,
                  options.showDetailsLink
                    ? CssClasses.inline
                    : CssClasses.hidden
                )
                .replace(
                  TOKENS.seeDetailsText,
                  options.seeDetailsText || '(See details)'
                )
                .replace(TOKENS.addOnSlug, getUrl(addOnDetails, 0))
                .replace(OPTIONS_TOKENS.addToCartInput, addCartHtml)
                .replace(TOKENS.price, priceDetails.price)
                .replace(OPTIONS_TOKENS.plusSign, options.showPlus ? '+' : '')
                .replace(
                  TOKENS.compareAtPrice,
                  options.showCompareAtPrice && priceDetails.hasCompareAtPrice
                    ? priceDetails.compareAtPrice
                    : ''
                )
                .replace(
                  OPTIONS_TOKENS.hasCompareAtPriceClassName,
                  options.showCompareAtPrice && priceDetails.hasCompareAtPrice
                    ? `${CssClasses.upsellPriceValue} ${CssClasses.hasCompareAtPrice}`
                    : CssClasses.upsellPriceValue
                )
                .replace(TOKENS.qtyLabel, options.qtyLabel || 'Qty:')
                .replace(
                  OPTIONS_TOKENS.variantDropdown,
                  variantDropdown(
                    addOnRecord.handle,
                    addOnDetails.variantOptions,
                    addOnDetails.variantOptionsLabel
                  )
                )
                .replace(TOKENS.description, addOnRecord.description || '');
              addonsHtmlOrder[i] = addOnHtml;
            } else {
              addonsHtmlOrder[i] = '';
            }
          } catch (err) {
            errorHandler(err);
          } finally {
            if (callCounts === addOns.length) {
              const allAddOnsHtml = addonsHtmlOrder.join(' ');
              callback(allAddOnsHtml);
            }
          }
        });
      }
    } catch (err) {
      errorHandler(err);
      removeUpsell();
    }
  }
}

function injectStyles(options, page) {
  let css = styles();
  const boxWidth =
    page === PAGE.Product
      ? options.productBoxWidth || ''
      : options.cartBoxWidth || '400px';
  const boxHeight =
    page === PAGE.Product
      ? options.productBoxHeight || ''
      : options.cartBoxHeight || '';
  const containerWidth =
    page === PAGE.Product
      ? options.productContainerWidth || ''
      : options.cartContainerWidth || '';
  const containerHeight =
    page === PAGE.Product
      ? options.productContainerHeight || ''
      : options.cartContainerHeight || '';
  let cartButtonWidth = options.cartButtonWidth;
  const boxWidthRegEx = new RegExp(STYLE_TOKENS.addOnBoxWidth, 'g');
  const boxHeightRegEx = new RegExp(STYLE_TOKENS.addOnBoxHeight, 'g');
  if (!cartButtonWidth) {
    if (
      page === PAGE.Product &&
      (options.productBoxType === BOX_TYPE.ImageTop ||
        options.productBoxType === BOX_TYPE.ImageLeft)
    ) {
      cartButtonWidth = '100%';
    } else if (
      page === PAGE.Cart &&
      (options.cartBoxType === BOX_TYPE.ImageTop ||
        options.cartBoxType === BOX_TYPE.ImageLeft)
    ) {
      cartButtonWidth = '100%';
    }
  }

  css = css
    .replace(
      STYLE_TOKENS.fontColor,
      options.textColor
        ? `color: ${
            options.textColor.indexOf('#') >= 0
              ? `${options.textColor}!important`
              : '#' + options.textColor
          };`
        : ''
    )
    .replace(
      STYLE_TOKENS.fontSize,
      options.titleSize ? `font-size:${options.titleSize}px!important;` : ''
    )
    .replace(
      STYLE_TOKENS.headerFontSize,
      options.headerFontSize
        ? `font-size: ${options.headerFontSize}px!important;`
        : ''
    )
    .replace(
      STYLE_TOKENS.headerColor,
      options.headerColor ? `color: ${options.headerColor}!important;` : ''
    )
    .replace(
      STYLE_TOKENS.borderWidth,
      options.showBorder ? `${options.borderWidth || 1}px` : '0px'
    )
    .replace(STYLE_TOKENS.borderColor, options.borderColor || '#95a5a6')
    .replace(STYLE_TOKENS.fontWeight, options.bold ? '700' : '400')
    .replace(
      STYLE_TOKENS.imageHeight,
      getImageDimension(
        'height',
        options.imageHeight,
        options.setInitialImageHeight,
        50
      )
    )
    .replace(
      STYLE_TOKENS.imageWidth,
      getImageDimension(
        'width',
        options.imageWidth,
        options.setInitialImageWidth
      )
    )
    .replace(STYLE_TOKENS.buttonHeight, options.cartButtonHeight || 35)
    .replace(
      STYLE_TOKENS.buttonWidth,
      cartButtonWidth ? `width:${cartButtonWidth}!important;` : ''
    )
    .replace(
      STYLE_TOKENS.buttonFontSize,
      options.cartButtonFontSize
        ? `${options.cartButtonFontSize}px!important;`
        : '0.75em'
    )
    .replace(
      STYLE_TOKENS.buttonPaddingLeft,
      getButtonPadding(options.cartButtonPaddingLeft)
    )
    .replace(
      STYLE_TOKENS.buttonPaddingTop,
      getButtonPadding(options.cartButtonPaddingTop)
    )
    .replace(
      STYLE_TOKENS.buttonPaddingRight,
      getButtonPadding(options.cartButtonPaddingRight)
    )
    .replace(
      STYLE_TOKENS.buttonPaddingBottom,
      getButtonPadding(options.cartButtonPaddingBottom)
    )
    .replace(boxWidthRegEx, boxWidth ? `width:${boxWidth};` : '')
    .replace(boxHeightRegEx, boxHeight ? `height:${boxHeight};` : '')
    .replace(STYLE_TOKENS.flexGrow, boxWidth ? '' : 'flex-grow:1;')
    .replace(STYLE_TOKENS.flexWrap, options.flexNoWrap ? 'nowrap' : 'wrap')
    .replace(
      STYLE_TOKENS.containerWidth,
      containerWidth ? `width:${containerWidth}!important;` : ''
    )
    .replace(
      STYLE_TOKENS.containerHeight,
      containerHeight ? `height:${containerHeight}!important;` : ''
    )
    .replace(
      STYLE_TOKENS.descriptionFontColor,
      options.descFontColor ? `color:${options.descFontColor};` : ''
    )
    .replace(
      STYLE_TOKENS.descriptionFontSize,
      options.descFontSize ? `font-size:${options.descFontSize}px;` : ''
    )
    .replace(
      STYLE_TOKENS.customCss,
      options.customCSS ? decodeURIComponent(options.customCSS) : ''
    );

  document.querySelector('head').insertAdjacentHTML('beforeend', css);
}

function getSubmitButton(options, form, page) {
  return page === PAGE.Product
    ? form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]') ||
        form.querySelector('.btn-addtocart') ||
        form.querySelector('button[name="add"]') ||
        form.querySelector('a.addtocart') ||
        (options.addToCartButtonSelector &&
          form.querySelector(options.addToCartButtonSelector))
    : form.querySelector('button[name="checkout"]') ||
        form.querySelector('input[name="checkout"]') ||
        (options.checkoutButtonSelector &&
          form.querySelector(options.checkoutButtonSelector));
}

function getAddToCartInputTemplate(options, page) {
  const template =
    page === PAGE.Product
      ? options.productInputTemplate
      : options.cartInputTemplate;
  return template ? decodeURIComponent(template) : null;
}

function getAddOnInput(
  options,
  page,
  addToCartButton,
  isGroupedVariant,
  productHandle
) {
  if (page === PAGE.Product) {
    if (options.quantitySelect) {
      return qtyBox(isGroupedVariant, productHandle);
    }

    if (options.addOnType === 'dropdown') {
      const qtyOptions = getQtyDropdownOptions(options);
      if (qtyOptions.length > 0) {
        return qtyDropdown(isGroupedVariant, productHandle, qtyOptions);
      }
    }

    if (options.addOnType === 'checkbox') {
      return checkbox(isGroupedVariant, productHandle);
    }
  }
  return button(addToCartButton, isGroupedVariant, productHandle);
}

function getForm(page, options) {
  let cartForm;
  if (page === PAGE.Product) {
    if (options.productPageFormSelector) {
      cartForm = document.querySelector(options.productPageFormSelector);
    } else {
      const allForms = document.querySelectorAll('form[action="/cart/add"]');
      if (allForms.length === 1) {
        cartForm = allForms[0];
      } else {
        for (let i = 0; i < allForms.length; i++) {
          if (isVisible(allForms[i])) {
            cartForm = allForms[i];
            break;
          }
        }
      }

      if (!cartForm) {
        cartForm = findForm('/cart/add');
      }
    }
  }

  if (page === PAGE.Cart) {
    if (options.cartPageFormSelector) {
      cartForm = document.querySelector(options.cartPageFormSelector);
    } else {
      cartForm = document.querySelector('form[action="/cart"]');

      if (!cartForm) {
        cartForm = findForm('/checkout');
      }

      if (!cartForm) {
        cartForm = findForm('/cart');
      }
    }
  }

  return cartForm;
}

function findForm(action) {
  const allForms = document.querySelectorAll('form');
  for (let i = 0; i < allForms.length; i++) {
    if (allForms[i].action && allForms[i].action.indexOf(action) >= 0) {
      return allForms[i];
    }
  }
}

function getAddOnInputTemplate(options, page) {
  const template =
    page === PAGE.Product
      ? options.productAddOnTemplate
      : options.cartAddOnTemplate;
  return template ? decodeURIComponent(template) : null;
}

function getPrices(options, addOnDetails, variantIndex) {
  const hasVariantOptions =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0;
  const compareAtPrice = hasVariantOptions
    ? addOnDetails.variantOptions[variantIndex].compareAtPrice
    : addOnDetails.compareAtPrice;
  const price = hasVariantOptions
    ? addOnDetails.variantOptions[variantIndex].price
    : addOnDetails.price;

  return getPriceDetails(options, price, compareAtPrice);
}

function getImageUrl(options, addOnDetails, variantIndex) {
  const image =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0
      ? options.useThumbnailImage
        ? addOnDetails.variantOptions[variantIndex].originalSmallImage
        : addOnDetails.variantOptions[variantIndex].image
      : options.useThumbnailImage
      ? addOnDetails.originalSmallImage
      : addOnDetails.image;
  return image || '';
}

function getUrl(addOnDetails, variantIndex) {
  const url =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0
      ? addOnDetails.variantOptions[variantIndex].url
      : addOnDetails.url;
  return url;
}

function isVisible(e) {
  return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}

function getQtyDropdownOptions(options) {
  if (options.quantityDropdownOptions) {
    return options.quantityDropdownOptions.split(',');
  }
  return [];
}
function getImageDimension(cssProperty, dimension, reset, defaultVal) {
  if (reset) {
    return `${cssProperty}:initial!important;`;
  }

  if (dimension) {
    return `${cssProperty}:${dimension}px!important;`;
  }

  return defaultVal ? `${cssProperty}:${defaultVal}px;` : '';
}

function getButtonPadding(paddingValue) {
  if (paddingValue === 0) {
    return 0;
  }
  return paddingValue || 1;
}
